// extracted by mini-css-extract-plugin
export default {"heading":"st-z","corrected":"tt-z","redirectVerbiageContainer":"ut-z","redirectVerbiageText":"vt-z"};